import React, { useEffect } from 'react';
import styles from './AdminTestimonials.module.css';
import ScrollReveal from 'scrollreveal';
import Button from '../ReceptionistComponents/button/Button';

import rec1 from '../recImages/rec1.png';
import rec2 from '../recImages/rec2.png';
import rec3 from '../recImages/rec3.png';
import rec4 from '../recImages/rec4.png';
import rec5 from '../recImages/rec5.png';
import rec6 from '../recImages/rec6.png';

const AdminTestimonials = () => {
  const images = [rec1, rec2, rec3, rec4, rec5, rec6];

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: '30px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });

    ScrollReveal().reveal(`.${styles.videoItem}`, {
      duration: 1000,
      distance: '40px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.15,
      interval: 150,
    });

    ScrollReveal().reveal(`.${styles.imageItem}`, {
      duration: 800,
      distance: '30px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.1,
      interval: 100,
    });
  }, []);

  return (
    <section className={styles.container} dir="rtl">
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>
          התגובות של התלמידות לא איחרו להגיע..
        </h2>

        <div className={styles.videosGrid}>
          <div className={styles.videoItem}>
            <div className={styles.videoWrapper}>
              <iframe
                src="https://player.vimeo.com/video/1195944499?badge=0&autopause=0&player_id=0&app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                allowFullScreen
                title="המלצה 1"
                className={styles.videoIframe}
              />
            </div>
          </div>
          <div className={styles.videoItem}>
            <div className={styles.videoWrapper}>
              <iframe
                src="https://player.vimeo.com/video/1195944501?badge=0&autopause=0&player_id=0&app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                allowFullScreen
                title="המלצה 2"
                className={styles.videoIframe}
              />
            </div>
          </div>
        </div>

        <div className={styles.imagesGrid}>
          {images.map((img, index) => (
            <div key={index} className={styles.imageItem}>
              <img
                src={img}
                alt={`המלצה ${index + 1}`}
                className={styles.image}
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <div className={styles.ctaSection}>
          <Button text="אני רוצה להצטרף להכשרה" />
        </div>
      </div>
    </section>
  );
};

export default AdminTestimonials;
